import type { EntityViewType, StaticEntityType } from "@config";
import classNames from "classnames";
import React, { type ReactNode } from "react";
import "../styles/index.scss";
import type { EditorSlotsProps } from "../types";
import { GroupStyled } from "./Group.styled";

export const GroupView = ({
  entity,
  children,
  editorSlots,
}: {
  entity: EntityViewType;
  children: ReactNode;
  editorSlots?: EditorSlotsProps;
}) => {
  const { settings, children: entityChildren, id } = entity as StaticEntityType;

  const isEmpty = entityChildren.length === 0;
  return (
    <GroupStyled
      data-is-empty={isEmpty}
      {...EDITOR_ATTRIBUTES({ id })}
      className={classNames(
        "group tw-relative [align-items:inherit] [justify-content:inherit] [text-align:inherit] max-md:!tw-w-full max-md:!tw-p-0",
        {
          "full-width": settings.groupWidth === "100",
          ["pos-" + settings.index]: true,
        },
      )}
      style={
        settings.comboMobileMediaWidth != null &&
        settings.comboMobileMediaWidth < 100
          ? ({
              "--combo-mobile-media-ratio":
                settings.comboMobileMediaWidth / 100,
              "--combo-mobile-media-capped": 1,
            } as React.CSSProperties)
          : undefined
      }
      $width={settings.groupWidth}
      $mobileOrder={settings.mobileOrder}
      $comboMobileMediaWidth={settings.comboMobileMediaWidth}
    >
      {isEmpty && editorSlots?.emptyStateSlot}
      {children}
    </GroupStyled>
  );
};

const EDITOR_ATTRIBUTES = ({ id }: { id: string }) => {
  const payload: Record<string, string | number> = {
    "data-layer-id": id,
    "data-layer-type": "group",
  };
  return payload;
};
